/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { DataGrid, Grid, IconButton } from 'src/components';
import { GridState } from 'src/models/GridState';
import { helper } from 'src/utils/helper';
import notify from 'src/utils/SnackbarUtils';

import VwPersonel from 'src/models/GenelTanimlar/VwPersonelDTO';
import personelListeService from 'src/services/Settings/Generals/personel.service';

import { useRaporTipPersonelEkleMutation } from 'src/services/RadyolojiModul/RadyolojiApi';
import GnlParametreSelect from 'src/parts/Genel/gnl.parametre.select';
import PersonelAutoComplete from 'src/parts/Personel/personel.autocomplete';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import RaporPersonelSlice from 'src/store/Slices/Raporlama/RaporPersonelSlice';
import api from 'src/services/core/api';
import { translate } from 'src/i18n/tHelper';


class VwPersonelState extends GridState<VwPersonel> {
  selectedTab: string;
}
const translatePath = "pages|personel";
const PersonelList = () => {
  const dispatch = useAppDispatch();
  const state1 = useAppSelector(s => s.raporlamaTanim);
  const personelIds = useAppSelector(s => s.raporPersonel.personelIds);

  const [state, setState] = useState<VwPersonelState>(new VwPersonelState());
  const [filterList, setFilterList] = useState(null);
  const [filterList1, setFilterList1] = useState(null);
  const [filterList2, setFilterList2] = useState(null);

  const [raporTipPersonelEkle] = useRaporTipPersonelEkleMutation();

  useEffect(() => {
    loadData();
  }, [filterList, filterList1, filterList2]);

  const loadData = async () => {
    setState(prev => ({
      ...prev,
      isLoading: true,
      isFetching: false
    }));
    const res = await personelListeService.find({
      filters: {
        groupOperator: 'and',
        predicates: [
          { fieldName: 'grupId', operator: 'like', value1: filterList },
          { fieldName: 'durumId', operator: 'like', value1: filterList1 },
          { fieldName: 'id', operator: 'like', value1: filterList2 }
        ]
      },
      sorts: helper.convertApiSorts(state.sortModel, {
        fieldName: 'id',
        ascending: true
      })
    });
    if (res.errorMessage) {
      notify.error(res.errorMessage);
      return;
    }
    setState(prev => ({
      ...prev,
      data: res.data,
      totalRecords: res.totalRecords,
      isLoading: false,
      isFetching: false
    }));
    dispatch(RaporPersonelSlice.actions.setFetchingPersonel(false));
  };

  return (
    <Grid container>
      <Grid md={6} xs={12} item>
        <GnlParametreSelect
          parametreType={ParametreGrupEnum.PersonelTurleri}
          label={translate(translatePath, "Grubu")}
          onChange={(e) => setFilterList(e.target.value)}
          name="grupId"
          value={filterList}
        />
      </Grid>
      <Grid md={6} xs={12} item>
        <GnlParametreSelect
          parametreType={ParametreGrupEnum.PersonelCalismaDurumu}
          label={translate(translatePath, "Durumu")}
          onChange={(e) => setFilterList1(e.target.value)}
          name="durumId"
          value={filterList1}
        />
      </Grid>
      <Grid md={12} xs={12} item>
        <PersonelAutoComplete
          label={translate(translatePath, "Personel Seçimi")}
          value={filterList2}
          onChange={(e, v) => setFilterList2(v?.id)}
          name="personelId"
        />
      </Grid>
      <Grid md={12} xs={12} item sx={{ height: '270px' }}>
        <DataGrid
          id="ServisPersonelList"
          colPropsButton
          enableQuickFilter
          pinnedColumns={{ right: ['action'] }}
          rows={state?.data?.filter(m => !personelIds.includes(m.id))}
          rowCount={state.totalRecords}
          loading={state.isLoading}
          initialState={{
            columns: { columnVisibilityModel: { id: false } }
          }}
          columns={[
            { field: 'id', headerName: translate(translatePath, "Kayıt No"), width: 120 },
            { field: 'adi', headerName: translate(translatePath, "Adı"), flex: 1, minWidth: 120 },
            { field: 'soyadi', headerName: translate(translatePath, "Soyadı"), flex: 1, minWidth: 120 },
            { field: 'kimlikNo', headerName: translate(translatePath, "Kimlik No"), flex: 1, minWidth: 120 },
            { field: 'durum', headerName: translate(translatePath, "Durumu"), width: 75 },
            { field: 'grup', headerName: translate(translatePath, "Grubu"), flex: 1, minWidth: 120 },
            {
              disableColumnMenu: true,
              field: 'action',
              headerName: translate(translatePath, "Ekle"),
              sortable: false,
              filterable: false,
              resizable: false,
              width: 40,
              renderCell: (params) => (
                <IconButton
                  customType="add"
                  onClick={async () => {
                    try {
                      await raporTipPersonelEkle({
                        id: 0,
                        personelId: params.row.id,
                        raportiptanimId: state1.activeRow.id,
                        turu: 1,
                      }).unwrap();

                      const personelListe = [...personelIds, params.row.id];
                      dispatch(RaporPersonelSlice.actions.setPersonelIds(personelListe));
                      dispatch(RaporPersonelSlice.actions.setFetchingPersonel(true));
                      dispatch(api.util.invalidateTags(["RaporPersonel"]));

                      notify.success(translate(translatePath, "Kayıt Eklendi"));
                    } catch (error: any) {
                      notify.error(error?.data?.message || translate(translatePath, "Ekleme sırasında hata oluştu."));
                    }
                  }}
                />
              )
            }
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default PersonelList;
